import { $Locale } from '@lemon8/web-app-shared/atom';
import { EURO_COUNTRY_SET } from '@lemon8/web-app-shared/i18n';
import { atom } from 'jotai';
import { $SEOEnterTraffic } from 'shared/atoms/common/traffic';

export const $EnablePintrk = atom((get) => {
  const { ipRegion } = get($Locale);
  const { href } = get($SEOEnterTraffic);

  let searchParams: URLSearchParams;
  try {
    searchParams = new URL(href).searchParams;
  } catch (e) {
    searchParams = new URLSearchParams();
  }

  return ['US_pinterest', 'JP_pinterest'].includes(searchParams.get('pid') || '') && !EURO_COUNTRY_SET.has(ipRegion);
});
